export enum DeviceMessageStatus {
    Pending,
    Sent,
    Failed,
    Deleted,
    Delivered,
    Expired,
}
